<template>
    <div class="goods">
        <a-form :from="queryForm" class="tenant-form" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item label="坐标系选择">
                <a-select placeholder="坐标系选择" @change="selectiveCoordinate" v-model="query.coordinateType"
                    v-decorator="['coordinateType', { rules: [{ required: true, message: '请选择坐标系' }], initialValue: 0 }]">
                    <a-select-option value="0">WGS84坐标系</a-select-option>
                    <a-select-option value="1">GCJ02坐标系</a-select-option>
                    <a-select-option value="2">BD09坐标系</a-select-option>
                    <a-select-option value="3">CGSC坐标系</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="原坐标">
                <a-input v-model="query.originalCoordinate" placeholder="请输入原坐标"
                    v-decorator="['originalCoordinate', { rules: [{ required: true, message: '请输入原坐标' }] }]" />
            </a-form-item>

            <a-form-item label="原坐标中央子午线">
                <a-input :disabled="(meridianFlag)" type="number" pattern="\d*" min="75" max="135" v-model="query.meridian"
                    placeholder="请输入中央子午线"
                    v-decorator="['meridian', { rules: [{ required: true, message: '请输入中央子午线' }] }]" />
            </a-form-item>

            <a-form-item label="转换中央子午线">
                <a-input type="number" pattern="\d*" min="75" max="135" v-model="query.transitionMeridian"
                    placeholder="请输入转换中央子午线"
                    v-decorator="['transitionMeridian', { rules: [{ required: true, message: '请输转换入中央子午线' }] }]" />
            </a-form-item>

            <a-form-item label="文件">
                <a-button style="margin-left: 8px;" @click="downloadTemplate({ execlForm: true })" type="primary">
                    <a-icon type="download" />下载模板
                </a-button>
                <a-button style="margin-left: 8px;" @click="convertFile" type="primary">
                    转换文件
                </a-button>

                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
                    <a-button type="primary" style="margin-left: 8px" :loading="exportLoading">
                        <a-icon type="upload" />选择文件
                    </a-button>
                </a-upload>

            </a-form-item>
            <a-form-item :wrapper-col="{ span: 14, offset: 4 }" style="margin-left: 6%;">
                <a-button type="primary" @click="transition">转换</a-button>
                <a-button style="margin-left: 8px" @click="resetForm">重置</a-button>
            </a-form-item>


        </a-form>

        <a-descriptions class="label" bordered title="转换结果" size="small">
            <a-descriptions-item label="WGS84坐标系" :span="3">
                {{ coordinateData.wgs84 }}
            </a-descriptions-item>
            <a-descriptions-item label="GCJ02坐标系" :span="3">
                {{ coordinateData.gcj02 }}
            </a-descriptions-item>
            <a-descriptions-item label="BD09坐标系" :span="3">
                {{ coordinateData.bd09 }}
            </a-descriptions-item>
            <a-descriptions-item label="CGCS坐标系" :span="3">
                {{ coordinateData.cgcs }}
            </a-descriptions-item>
        </a-descriptions>

        <a-descriptions bordered title="解释" size="small">
            <a-descriptions-item label="WGS84坐标系" :span="3">
                地球坐标系,国际通用坐标系; Google海外地图使用
            </a-descriptions-item>
            <a-descriptions-item label="GCJ02坐标系" :span="3">
                火星坐标系, WGS84坐标系加密后的坐标系; Google国内地图、高德、QQ地图 使用
            </a-descriptions-item>
            <a-descriptions-item label="BD09坐标系" :span="3">
                百度坐标系, GCJ02坐标系加密后的坐标系
            </a-descriptions-item>
            <a-descriptions-item label="CGCS坐标系" :span="3">
                国家2000大地坐标系
                <br />
                <span style="color: red; font-size: 12px;">注:此系统使用114中央子午线</span>
            </a-descriptions-item>
        </a-descriptions>
    </div>
</template>
  
<script>
import mixinViewModule from '@/mixin/common'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import axios from 'axios'
export default {
    name: 'CoordinateConvert',
    mixins: [mixinViewModule],
    props: {
        treeData: {
            type: Array,
            default: function () {
                return []
            }
        },
        exportUrl: {
            type: String
        }
    },
    data () {
        return {
            exportLoading: false,
            fileList: [],
            selectId: '',
            needQuery: false,
            selectUrl: 'pipe-network/coordinate/transition',
            exportExcelData: 'pipe-network/coordinate/template/download',
            downloadTemplateUrl: 'pipe-network/coordinate/template/download', // 模板
            downloadTemplateName: '坐标系转换模板.xlsx',
            convertFileUrl: 'pipe-network/coordinate/import/transition',
            modalWidth: 800,
            visible: false,
            meridianFlag: true,

            coordinateData: {
                wgs84: '',
                gcj02: '',
                bd09: '',
                cgcs: ''
            },
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 }
            },

            query: {
                coordinateType: undefined,
                originalCoordinate: undefined,
                meridian: undefined,
                transitionMeridian: '114',
            },
            queryForm: this.$form.createForm(this, { name: 'query' }),
        }
    },
    methods: {
        selectiveCoordinate (info) {
            console.log(info);
            if (info == 3) {
                this.meridianFlag = false
            } else {
                this.meridianFlag = true
                this.query.meridian = undefined
                this.query.transitionMeridian = '114'
            }
        },
        convertFile () {
            if (this.fileList.length) {

                if (this.query.coordinateType == undefined) {
                    this.$message.error('请选择坐标系')
                    return;
                } else if (this.query.coordinateType != '3') {
                    this.$message.error('文件只支持转换CGCS坐标系')
                    return;
                } else if (this.query.meridian == '' || this.query.meridian == undefined) {
                    this.$message.error('请填写原坐标中央子午线')
                    return;
                }

                console.log(this.query);
                const formData = new FormData()
                formData.append('file', this.fileList[0])
                formData.append('parameter', JSON.stringify(this.query))

                let url = `${process.env.VUE_APP_API_BASE_URL}${this.convertFileUrl}`
                const tenantId = storage.get('tenantId')

                const head = storage.get(ACCESS_TOKEN)
                const instance = axios.create({
                    // 设置基本的请求配置，如基本URL、请求超时时间等
                    baseURL: url
                })
                instance.defaults.responseType = 'arraybuffer'
                let fileName = '转换后坐标数据.xlsx'
                instance.post(url, formData, {
                    headers: { 
                        'Authorization': head,
                        'tenantId': tenantId
                    }
                }).then((res) => {
                    console.log(res)
                    const blob = new Blob([res.data], {
                        type: 'application/octet-stream;charset=utf-8'
                    })

                    const eLink = document.createElement('a')
                    eLink.download = fileName
                    eLink.style.display = 'none'
                    eLink.href = URL.createObjectURL(blob)
                    document.body.appendChild(eLink)
                    eLink.click()
                    URL.revokeObjectURL(eLink.href)
                    document.body.removeChild(eLink)
                    this.$message.success('导出完成')
                }).catch((error) => {
                    console.log(error)
                }).finally(() => {
                    this.exportLoading = false
                    this.resetForm()
                    this.close()
                })
            } else {
                this.$message.error('请选择上传文件')
            }
        },
        transition () {
            console.log(this.query);
            if (this.query.coordinateType == undefined) {
                this.$message.error('请选择坐标系')
                return;
            } else if (this.query.originalCoordinate == '' || this.query.originalCoordinate == undefined) {
                this.$message.error('请填写原坐标')
                return;
            } else if (this.query.coordinateType == '3' && (this.query.meridian == '' || this.query.meridian == undefined)) {
                this.$message.error('请填写中央子午线')
                return;
            } else if (this.query.coordinateType == '3' && (this.query.meridian > 135 || this.query.meridian < 75)) {
                this.$message.error('我国使用的中央子午线范围为72°-135°')
                return;
            }

            let pattern = /^\d+\.\d+,\d+\.\d+$/;
            console.log(pattern.test(this.query.originalCoordinate));
            if (!pattern.test(this.query.originalCoordinate)) {
                this.$message.error('请填写正确坐标格式如: 116.41,39.90')
                return;
            }

            this.axios({
                method: 'get',
                url: this.selectUrl,
                headers: {},
                params: this.query
            }).then(response => {
                console.log(response.data);

                this.coordinateData = {
                    wgs84: response.data.wgs84.x + ',' + response.data.wgs84.y,
                    gcj02: response.data.gcj02.x + ',' + response.data.gcj02.y,
                    bd09: response.data.bd09.x + ',' + response.data.bd09.y,
                    cgcs: response.data.cgcs.x + ',' + response.data.cgcs.y
                }
            }).catch(function (error) {
                console.log(error)
            }).finally(() => {
                this.exportLoading = false
                this.close()
            })

        },
        resetForm () {
            //重置表单
            this.query = {
                coordinateType: undefined,
                originalCoordinate: undefined,
                meridian: undefined,
                transitionMeridian: '114',
            }
            this.coordinateData = {}
        },


        handleRemove (file) {
            const index = this.fileList.indexOf(file)
            const newFileList = this.fileList.slice()
            newFileList.splice(index, 1)
            this.fileList = newFileList
        },
        beforeUpload (file, fileList) {
            this.fileList = [...this.fileList, file]
            // 限制文件只能上传一个
            this.fileList = this.fileList.slice(-1)
            return false
        },
        changeFile (info) { },
        saveFile (formData) {
            this.exportLoading = true
            this.axios({
                method: 'post',
                url: this.exportUrl,
                headers: {},
                params: {},
                data: formData
            })
                .then(response => {
                    if (response.code === 0) {
                        this.close()
                        this.$message.success(response.message)
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
                .finally(() => {
                    this.exportLoading = false
                    this.close()
                })
        },
        show () {
            this.exportLoading = false
            this.visible = true
            // this.init()
        },
        handleCancel () {
            this.close()
        },
        close () {
            this.visible = false
            this.fileList = []
            this.selectId = ''
            //   this.disableSubmit = false
        },
        handleOk () {
            if (!this.selectId) {
                this.$message.error('请选择一个分区')
            } else if (this.fileList.length) {
                const formData = new FormData()
                formData.append('file', this.fileList[0])
                formData.append('zone_id', this.selectId)
                this.saveFile(formData)
            } else {
                this.$message.error('请选择上传文件')
            }
        }
    }
}
</script>
  
<style lang="less" scoped>
/deep/ .ant-descriptions-item-label {
    width: 350px;
}



.tenant-form {
    width: 70%;
    margin: 0 auto;
}

.query-button {
    margin-left: 21.5%;
}
</style>
  